import { render, staticRenderFns } from "./btn-clave-unica.vue?vue&type=template&id=f9131180&scoped=true"
import script from "./btn-clave-unica.vue?vue&type=script&lang=js"
export * from "./btn-clave-unica.vue?vue&type=script&lang=js"
import style0 from "./btn-clave-unica.vue?vue&type=style&index=0&id=f9131180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9131180",
  null
  
)

export default component.exports